import './index.scss'
$(".section5 ul li").click(function() {
    $(this).find(".text").slideToggle();
    $(this).toggleClass("active");
})